import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { MarkdownPage } from "../../components/MarkdownPage";
import { SeoHead } from "../../components/SeoHead";
import { getArticle, ARTICLE_LOADERS } from "../../../content/blog/registry";
import "./BlogArticlePage.css";

const SITE_URL = "https://trend.nasonov.fun";
const toAbsolute = (path?: string) => path ? `${SITE_URL}${path}` : undefined;

export const BlogArticlePage: React.FC = () => {
  const { slug = "" } = useParams<{ slug: string }>();

  const meta = getArticle(slug);
  const loader = ARTICLE_LOADERS[slug];

  if (!loader || !meta) return <Navigate to="/blog" replace />;

  const breadcrumbs = [
    { name: "Trend", url: SITE_URL },
    { name: "Блог", url: `${SITE_URL}/blog` },
    { name: meta.title, url: `${SITE_URL}/blog/${slug}` },
  ];

  return (
    <>
      <SeoHead
        title={meta.title}
        description={meta.description}
        canonical={`/blog/${slug}`}
        type="article"
        publishedAt={meta.publishedAt}
        updatedAt={meta.updatedAt}
        readTime={meta.readTime}
        breadcrumbs={breadcrumbs}
        image={toAbsolute(meta.ogImage)}
      />
      <nav className="blog-breadcrumb" aria-label="Навигация">
        <div className="blog-breadcrumb__inner">
          <Link to="/" className="blog-breadcrumb__link">Главная</Link>
          <span className="blog-breadcrumb__sep" aria-hidden="true">›</span>
          <Link to="/blog" className="blog-breadcrumb__link">Блог</Link>
          <span className="blog-breadcrumb__sep" aria-hidden="true">›</span>
          <span className="blog-breadcrumb__current" aria-current="page">{meta.title}</span>
        </div>
      </nav>
      <MarkdownPage
        contentPath={() => loader()}
        kicker="Блог"
      />
    </>
  );
};
